var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3795 14.2478L7.12646 24.5009L9.24779 26.6222L21.6222 14.2478L9.24778 1.87347L7.12646 3.99479L17.3795 14.2478Z",
    fill: "#f0f0f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevronWhite);
export default __webpack_public_path__ + "static/media/rightChevronWhite.0d6653f5367ceea42ecc7fde3e645e9c.svg";
export { ForwardRef as ReactComponent };